/**
 * `notifications` namespace — Korean translations.
 *
 * Mirrors `en/notifications.ts` exactly; the `Record<NotificationsKey, string>`
 * annotation makes a missing or misspelled key a compile error. Notification→알림.
 * Delivery channels localize to 웹·푸시·이메일; AI/FGI-style tech nouns stay English.
 */
import type { NotificationsKey } from "../en/notifications";

export const notifications: Record<NotificationsKey, string> = {
  eyebrow: "활동",
  title: "알림",
  description: "시그널, 주문 이벤트, 승인, AI 판정, 리스크 위반.",
  markAllRead: "모두 읽음 처리",

  loadError: "알림을 불러오지 못했습니다. 다시 시도해 주세요.",
  emptyTitle: "표시할 내용 없음",
  emptyAll: "전략의 활동이 여기에 표시됩니다.",
  emptyFiltered: "이 필터에 해당하는 알림이 없습니다.",

  filterAll: "전체",
  filterUnread: "안 읽음",

  priorityHigh: "높음",
  markRead: "읽음 처리",

  eventSignal: "시그널",
  eventOrderPlaced: "주문 제출",
  eventOrderFilled: "주문 체결",
  eventApprovalRequested: "승인 요청",
  eventAiVerdict: "AI 판정",
  eventRiskBreach: "리스크 위반",
  eventError: "오류",

  policyEventCol: "이벤트",
  channelWeb: "웹",
  channelPush: "푸시",
  channelEmail: "이메일",
  channelToggleAria: "{channel}(으)로 {event}",
  minPriorityLabel: "최소 우선순위",
  minPriorityHint: "이 기준보다 낮은 항목은 모든 채널에서 억제합니다.",
  priorityLowAll: "낮음 — 전체",
  priorityNormalUp: "보통 이상",
  priorityHighOnly: "높음만",
  quietHours: "방해 금지 시간",
  enable: "사용",
  quietStartAria: "방해 금지 시작",
  quietEndAria: "방해 금지 종료",
  quietOff: "꺼짐 — 시간과 무관하게 전송합니다.",
  savePolicy: "정책 저장",
  discard: "되돌리기",
  policyLoadError: "알림 정책을 불러오지 못했습니다.",
};
